export const AlarmWarning = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.98438 1.83594C7.74238 1.83594 7.56038 1.95367 7.43971 2.18848L1.38638 13.2294C1.20571 13.6996 1.50771 14.1693 1.99238 14.1693H14.037C14.521 14.1693 14.8237 13.6996 14.5817 13.2882L8.52904 2.18784C8.40838 1.95367 8.16571 1.83594 7.98438 1.83594ZM7.37904 6.53416H8.58971V9.47097H7.37904V6.53416ZM8.58971 11.8198H7.37904V10.6451H8.58971V11.8198Z"
            fill="#FFC414"
        />
        <path
            d="M7.98438 3.65625L13.0684 12.9945H2.90038L7.98438 3.65625ZM7.98438 1.83594C7.74238 1.83594 7.56038 1.95367 7.43971 2.18848L1.38638 13.2294C1.20571 13.6996 1.50771 14.1693 1.99238 14.1693H14.037C14.521 14.1693 14.8237 13.6996 14.5817 13.2882L8.52904 2.18784C8.40838 1.95367 8.16571 1.83594 7.98438 1.83594Z"
            fill="#121212"
        />
        <path
            d="M8.58971 6.53416H7.37904V9.47097H8.58971V6.53416ZM7.37904 11.8198H8.58971V10.6451H7.37904V11.8198Z"
            fill="#121212"
        />
    </svg>
);
